<template>
  <div>
    <h2>{{ title }}</h2>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <div v-on:keypress.enter.prevent="getGroupVisitTable(1)">
          <input-search
            :model="search" @update="searchInput"/>
        </div>
        <circle-button
          v-if="permissionGroupVisit && permissionGroupVisit.permission_id === permission.readWrite"
          @click.native="createGroupVisit" />
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center" v-for="header in headers" :key="header.id">
                {{ header.text }}
                <template v-if="header.icon">
                  <a @click="sortDataTable(header.id)">
                    <v-icon class="fas fa-caret-down"
                            v-if="sort == 'desc'"
                            style="font-size: 12px"></v-icon>
                    <v-icon class="fas fa-caret-up"
                            v-if="sort == 'asc'"
                            style="font-size: 12px"></v-icon>
                  </a>
                </template>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dataTable" :key="item.id">
              <td align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
              <td>{{ item.branch ? item.branch.branch_name_th : "" }}</td>
              <td>{{ item.title_th }}</td>
              <td>{{ item.contact_email }}</td>
              <td>{{ item.updated_at | moment("DD-MM-YYYY") }}</td>
              <td>
                <a @click="showGroupVisitData(item.id)">
                  <icon-pencil />
                </a>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
import InputSearch from "../../../components/Input/InputSearch";
import CircleButton from "../../../components/Button/CircleButton";
import IconPencil from "../../../components/Icon/icon-pencil";
import Paginate from "../../../components/Layout/Paginate";
import {permissionGroupVisit, role} from "../../../util/Permission";
import {mapState} from "vuex";
import Loading from 'vue-loading-overlay';
export default {
  name: "GroupVisitTable",
  components: {Paginate, IconPencil, CircleButton, InputSearch, Loading },
  data() {
    return {
      title: "Group Visit",
      isLoading: false,
      headers: [
        { id: 1, text: "No." ,icon : null},
        { id: 11, text: "Branch" ,icon : true},
        { id: 3, text: "Group visit" ,icon : null},
        { id: 4, text: "Contact email" ,icon : null},
        { id: 22, text: "Update date" ,icon : true},
        { id: 6, text: "edit" ,icon : null}
      ],
      dataTable: [],
      dataPaginate: {
        current_page: 1,
        from: 1,
        last_page: 1,
        per_page: 1,
        total: 1,
        to: 1
      },
      permission : null,
      search : '',
      sort : 'desc',
      sort_branch : 'desc',
      sort_date : 'desc',
    };
  },
  computed: {
    permissionGroupVisit,
  },
  created() {
    this.permission = role;
    this.getGroupVisitTable(1);
  },

  methods: {
    getGroupVisitTable(page) {
      this.isLoading = true;
      this.$store.dispatch("GroupVisit/getGroupVisit", {
        page,
        search : this.search,
        sort_date : this.sort_date,
        sort_branch : this.sort_branch,
      }).then(res => {
        if (res.response_code == 200) {
          this.dataTable = res.result.data;
          this.dataPaginate = {
            current_page: res.result.current_page,
            from: res.result.from,
            last_page: res.result.last_page,
            per_page: res.result.per_page,
            total: res.result.total,
            to: res.result.to
          }
        } else {
          Swal(res.response_msg);
        }
        this.isLoading = false;
      });
    },
    async changePage(val){
      this.isLoading = true;
      this.dataPaginate.current_page = val;
      await this.getGroupVisitTable(this.dataPaginate.current_page);
      this.isLoading = false;
    },
    goTOGroupVisitEdit() {
      this.$router.push("/group-visit/edit");
    },
    showGroupVisitData(id) {
      this.isLoading = true;
      this.$store.dispatch("GroupVisit/showGroupVisit", id).then(res => {
        if (res.response_code == 200) {
          this.$store.dispatch("GroupVisit/setFormGroupVisit", res.result).then(() => {
            this.goTOGroupVisitEdit();
          });
        } else {
          Swal(res.response_msg);
        }
        this.isLoading = false;
      });
    },
    createGroupVisit() {
      this.$store.dispatch("GroupVisit/clearFormData").then(() => {
        this.goTOGroupVisitEdit();
      });
    },
    searchInput(val){
      this.search = val;
    },
    sortDataTable(header_id){
      this.sort = this.sort == 'desc' ? 'asc' : 'desc';
      if(header_id === 11){ //sort by branch
        this.sort_branch = this.sort_branch == 'desc' ? 'asc' : 'desc';
      }
      if(header_id === 22){ //sort by updated_at
        this.sort_date = this.sort_date == 'desc' ? 'asc' : 'desc';
      }
      this.getGroupVisitTable(1);
    }
  }
};
</script>

<style scoped>
@import "../../../assets/css/table.css";
.branch-data {
  background-color: transparent;
  margin: 20px;
}
</style>
